<template>
    <div class="adddeviceType">
       <div>
           <ul>
               <li @click="scanQrCode('scanQr')">{{$t('addDevice.scanQRC')}}</li>
               <li @click="scanQrCode('inputNum')">{{$t('addDevice.inputQRC')}}</li>
           </ul>
           <el-button @click="cancel">{{$t('addDevice.cancel')}}</el-button>
       </div>
    </div>
</template>
<script>
export default {
    name:'adddeviceType',
    data() {
      return {
        
      }
    },
    methods: {
      scanQrCode(type){
          console.log(type)
          this.$emit("addDevice",type)
          switch(type){
            case 'scanQr':
            this.$router.push("/addDevice");
            break;
            case 'inputNum':
            this.$router.push("/bindById");
            break;
          }
      },
      cancel(){
          this.$emit('cancelModel',false)
      }
    }
}
</script>
<style>
    body{
        position: relative;
    }
</style>
<style scoped>
    .adddeviceType{
        position: absolute;
        z-index: 999;
        width: 100%;
        height: 100%;
        top: 0;
        background: rgba(0, 0, 0, 0.23);
    }
    .adddeviceType div{
        width: 100%;
        position: fixed;
        bottom: 0;
        padding-top: 0.5rem;
        text-align: center;
        font-size: 1rem;
        color: #666666;
    }
    .adddeviceType div ul{
        width: 92%;
        margin: 0 auto;
        border-radius: 0.8rem;
        background: #ffffff;
    }
    .adddeviceType div ul li{
        height: 3.2rem;
        line-height: 3.2rem;
    }
    .adddeviceType div ul li:first-child{
        border-bottom:  1px solid #e1e1e1;
    }
    .adddeviceType div .el-button{
        width: 92%;
        border-radius: 0.68rem;
        height: 3.2rem;
        line-height: 3.2rem;
        padding: 0 0;
        margin: 0.5rem 0 0.8rem 0;
        font-size: 1rem;
        color: #666666;
    }
</style>



// WEBPACK FOOTER //
// src/m_page/home/adddeviceType.vue